import {styled} from "@mui/material/styles"
import {CardContent, Typography, TypographyProps} from "@mui/material"
import Grid from "@mui/material/Grid"

const ColoredTypography = styled(({color, ...props}: {color: string} & TypographyProps) => <Typography {...props} />)`
	color: ${(props) => props.color};
`

const ColoredTypographyWithBottomMargin = styled(ColoredTypography)`
	margin-bottom: 2px;
`

const CardHeadingTypography = styled(ColoredTypography)`
	font-weight: 500;
`

const StyledDiv = styled("div")`
	display: flex;
	align-items: center;
`

const CardContentLessPadding = styled(CardContent)`
	padding: 0 16px;
	padding-bottom: 10px !important;
`

const GridWithBottomMargin = styled(Grid)`
	margin-bottom: 10px;
`

export {
	GridWithBottomMargin,
	CardContentLessPadding,
	StyledDiv,
	CardHeadingTypography,
	ColoredTypographyWithBottomMargin,
	ColoredTypography,
}
